import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ProjectOutput } from 'core/http/dev';
import { apiUrl } from 'core/http/lg-logistic-rest-api/api/api.service';
import { CourierOutput } from 'core/http/root/courier.service';
import { Observable } from 'rxjs';
import { Criteria } from 'shared/criteria/Criteria';

export interface DocumentOutput {
  id: string;
  name: string;
  courier: CourierOutput;
  projects: ProjectOutput[];
  type: 'POST_BLANK' | 'REVISION' | 'SUMMARY';
}

@Injectable()
export class DocumentService {
  constructor(private http: HttpClient) {}

  getAllDocuments(criteria?: Criteria): Observable<DocumentOutput[]> {
    return this.http.get<DocumentOutput[]>(apiUrl(`/root/extensions/document`, criteria));
  }
}
